import { ProjectsView } from 'features/projects';

const ProjectsPage = () => <ProjectsView />;

export default ProjectsPage;
